import { render, staticRenderFns } from "./UpsertScheduleItemWrapper.vue?vue&type=template&id=8fb8c47a&lang=pug&"
import script from "./UpsertScheduleItemWrapper.vue?vue&type=script&lang=js&"
export * from "./UpsertScheduleItemWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UpsertScheduleItemWrapper.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports